<div *ngIf="!isSipSubscribed">
  <div *ngIf="config?.v.toString()?.match('v2')" class="list">
    <ng-container [ngTemplateOutlet]="sippitchBanner"></ng-container>
  </div>
  <div *ngIf="config?.v.toString()?.match('v1')" class="app-btn">
    <ng-container [ngTemplateOutlet]="sippitchCard"></ng-container>
  </div>
</div>

<ng-template #sippitchBanner>
  <div class="sippitchbanner" (click)="redirect('banner')">
    <img loading="lazy" src="../assets/images/sip-by-ketto.png" alt="">
    <div class="content">
      <div class="title">{{userData? userData?.fname +', you inspire us!' : "100+ lives saved last month!"}}</div>
      <div *ngIf="userData && userData?.aggdonationall?.funds < 1" class="sub">{{'Thanks to '+(sipDonors?.monthlyDonors | inrFormat:'INR')+' Ketto SIP donors. Start your Ketto SIP journey today!'}}</div>
      <div *ngIf="userData && userData?.aggdonationall?.funds >= 1" class="sub" [innerHTML]="livesChanged"></div>
      <div *ngIf="!userData" class="sub">{{'Thanks to '+(sipDonors?.monthlyDonors | inrFormat:'INR')+' Ketto SIP donors. Start your Ketto SIP journey today!'}}</div>
    </div>
    <em class="material-icons">chevron_right</em>
  </div>
</ng-template>

<ng-template #sippitchCard>
  <div class="sippitchcard">
    <div class="part1">
      <div class="content">
        <div class="title">Biggest impact made every month with Ketto SIP</div>
        <div class="sub">
          <img loading="lazy" src="../assets/images/donors.png" alt="">
          <div class="para">{{sipDonors?.monthlyDonors | inrFormat:'INR'}} monthly donors</div>
        </div>
      </div>
      <img loading="lazy" class="img1" src="../assets/images/sip-by-ketto.png" alt="">
      <img class="img2" src="../assets/images/banner-5.png" alt="">
    </div>
    <div class="part2">
      <div class="list" *ngFor="let item of list">
        <em class="material-icons"><strong>done</strong></em>
        <div class="list-item" [innerHTML]="item.label"></div>
      </div>
      <div class="sub">Come join our comunity of {{sipDonors?.monthlyDonors | inrFormat:'INR'}}+ SIP donors</div>
      <div class="button">
        <button mat-button  class="btn" (click)="redirect('pitchcard')">
          {{userData? 'Join Ketto SIP' : 'Get Started'}}
        </button>
      </div>
    </div>
  </div>
</ng-template>